function setCookie() {
  const cookieName = 'clarivate_cookie_policy';
  const cookieValue = 1;
  const d = new Date();
  const path = 'path=/';
  d.setMonth(d.getMonth() + 1);
  document.cookie = `${cookieName}=${cookieValue};expires=${d.toGMTString()};${path}`;
}

export default { setCookie };



// WEBPACK FOOTER //
// ./src/js/custom/set-cookie.js